var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 11.112 11.112",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-66.86 -87.152)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.95432 0 0 .95432 3.3188 4.2458)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m66.86 97.244v-9.0929c0-0.13232 0.0258-0.2595 0.0759-0.38259 0.0513-0.12206 0.12308-0.22976 0.21642-0.3231 0.0944-0.09436 0.20207-0.16616 0.32414-0.21642 0.12204-0.05128 0.25027-0.07693 0.38258-0.07693h9.0919c0.13334 0 0.26053 0.02563 0.38258 0.07693 0.12207 0.05026 0.23081 0.12206 0.32413 0.21642 0.0933 0.09334 0.16514 0.20104 0.21642 0.3231 0.0502 0.12308 0.0759 0.25027 0.0759 0.38259v9.0929c0 0.13232-0.0258 0.25951-0.0759 0.38156-0.0513 0.12206-0.12307 0.23078-0.21642 0.32412-0.0933 0.09334-0.20206 0.16616-0.32413 0.21643-0.12205 0.05024-0.24924 0.0759-0.38258 0.0759h-9.0919c-0.13231 0-0.26054-0.0256-0.38258-0.0759-0.12207-0.05024-0.22976-0.12309-0.32414-0.21643-0.0933-0.09334-0.16513-0.20206-0.21642-0.32412-0.0502-0.12205-0.0759-0.24924-0.0759-0.38156z",
    fill: "#0097ba"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m75.33 93.733c0 0.46157-0.37334 0.8339-0.83389 0.83492h-4.1746c-0.46054-1e-3 -0.8339-0.37336-0.83493-0.83492v-2.3325c0-0.46054 0.37439-0.83287 0.83493-0.83492h4.1746c0.46055 0.0021 0.83286 0.37438 0.83389 0.83492zm-3.5253-0.45131 1.5796-0.81749-1.5796-0.81749z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.4822668a8120f644e2572d008fcf400c.svg";
export { ForwardRef as ReactComponent };